import { OTHER_DETAILS_LOADING, OTHER_DETAILS_SUCCESS, OTHER_DETAILS_FAILED, SAVE_OTHER_DETAILS_LOADING, SAVE_OTHER_DETAILS_SUCCESS, SAVE_OTHER_DETAILS_FAILED } from '../Constants/otherDetailsConstants';

export const otherDetailsReducer = (
    state = { otherDetailsData: [] },
    action
) => {
    switch (action.type) {
        case OTHER_DETAILS_LOADING:
            return { loading: true, otherDetailsData: [] };
        case OTHER_DETAILS_SUCCESS:
            return { loading: false, otherDetailsData: action.payload };
        case OTHER_DETAILS_FAILED:
            return { loading: false, error: action.otherDetailsData };
        default:
            return state;
    }
};

export const saveOtherDetailsReducer = (
  state = { saveOtherDetailsData: [] },
  action
) => {
  switch (action.type) {
    case SAVE_OTHER_DETAILS_LOADING:
      return { loading: true, saveOtherDetailsData: [] };
    case SAVE_OTHER_DETAILS_SUCCESS:
      return { loading: false, saveOtherDetailsData: action.payload };
    case SAVE_OTHER_DETAILS_FAILED:
      return { loading: false, error: action.saveOtherDetailsData };
    default:
      return state;
  }
}